// extracted by mini-css-extract-plugin
export default {"listHeader":"AppointmentSlotComponent_listHeader__AaxW-","time":"AppointmentSlotComponent_time__aBMJ7","storyBackground":"AppointmentSlotComponent_storyBackground__1WDOD"};